/**
 * Тип проекта
 * Портировано из backend/properties/proto/entities/entities.proto
 */
export enum ProjectType {
  INVALID = 0,
  RESIDENTIAL_COMPLEX = 1,
  GATED_COMMUNITY = 2,
  HOLIDAY_HOMES = 3,
  COMMERCIAL_REAL_ESTATE = 4,
}

export const ProjectTypeDisplayNames: Record<ProjectType, string> = {
  [ProjectType.INVALID]: 'Неизвестно',
  [ProjectType.RESIDENTIAL_COMPLEX]: 'Жилой комплекс',
  [ProjectType.GATED_COMMUNITY]: 'Закрытое сообщество',
  [ProjectType.HOLIDAY_HOMES]: 'Дома отдыха',
  [ProjectType.COMMERCIAL_REAL_ESTATE]: 'Коммерческая недвижимость',
}

/**
 * Получить локализационный ключ для типа проекта
 */
export function getProjectTypeKey(type: ProjectType | string): string {
  // Если пришла строка (из API), пытаемся найти соответствующий enum
  if (typeof type === 'string') {
    const enumKey = type.replace('PROJECT_TYPE_', '')
    const enumValue = ProjectType[enumKey as keyof typeof ProjectType]
    if (enumValue !== undefined) {
      type = enumValue
    }
  }

  const keyMap: Record<ProjectType, string> = {
    [ProjectType.INVALID]: 'menu.residential_complexes',
    [ProjectType.RESIDENTIAL_COMPLEX]: 'menu.residential_complexes',
    [ProjectType.GATED_COMMUNITY]: 'menu.gated_communities',
    [ProjectType.HOLIDAY_HOMES]: 'menu.holiday_homes',
    [ProjectType.COMMERCIAL_REAL_ESTATE]: 'menu.commercial_real_estate',
  }

  return keyMap[type as ProjectType] || 'menu.residential_complexes'
}
